export default __webpack_public_path__ + "static/media/highest.6c76ad91.svg";